<template>
  <div class="container">
    <img  src="../../assets/images/logistics-inform.png" />
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.container img{
  width: 100%;
}
</style>
